import React from 'react';
import PostAddRoundedIcon from '@material-ui/icons/PostAddRounded';
import strings from 'strings';
import FPIconButton from 'UI/components/atoms/FPIconButton';

export const CreateMultipleActivitiesButton = ({ onClick }) => {
  return (
    <FPIconButton
      onClick={onClick}
      showTooltipWhenDisabled
      icon={PostAddRoundedIcon}
      tooltipProps={{
        arrow: false,
        placement: 'bottom',
        title: strings.inventory.shared.listing.addActivities
      }}
      iconProps={{
        onSetColor: ({ primary }) => primary.main
      }}
    />
  );
};
